module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 009.845dfd6f.jpg";